export enum RunDetailType {
    Stats = 1,
    Progress = 2,
    Log = 3,
    Image = 4,
    Failure = 5,
    Html = 6
}